// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.nav .nav-link.filter-link {
    text-decoration: none;
    color: #72777c;
    padding: 0;
    margin-right: 30px;
    float: left;
}

.nav-link.filter-link.active {
    color: #000;
    border-bottom: 2px solid var(--main-color);
    box-shadow: 0 4px 6px -6px var(--main-color);
}


@media screen and (min-width: 768px) {
    .nav.filter {
        margin-top: 60px;
    }
}



@media only screen and (max-width: 767px) {
    nav.nav.filter {
        display: block;
        padding-bottom: 140px;
    }

    .nav a.nav-link.filter-link {
        width: 100%;
        display: block;
        vertical-align: middle;
        text-align: center;
        padding: 5px;
        border: 1px solid #ccc;
        background-color: #ccc;
        margin-top: 5px;
        color: #72777c;
    }

    .nav a.nav-link.filter-link.active {
        background-color: #fff;
        color: #72777c;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/search/filterSearch/filter-search.component.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C,4CAA4C;AAChD;;;AAGA;IACI;QACI,gBAAgB;IACpB;AACJ;;;;AAIA;IACI;QACI,cAAc;QACd,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,cAAc;QACd,sBAAsB;QACtB,kBAAkB;QAClB,YAAY;QACZ,sBAAsB;QACtB,sBAAsB;QACtB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,cAAc;IAClB;AACJ","sourcesContent":["\r\n.nav .nav-link.filter-link {\r\n    text-decoration: none;\r\n    color: #72777c;\r\n    padding: 0;\r\n    margin-right: 30px;\r\n    float: left;\r\n}\r\n\r\n.nav-link.filter-link.active {\r\n    color: #000;\r\n    border-bottom: 2px solid var(--main-color);\r\n    box-shadow: 0 4px 6px -6px var(--main-color);\r\n}\r\n\r\n\r\n@media screen and (min-width: 768px) {\r\n    .nav.filter {\r\n        margin-top: 60px;\r\n    }\r\n}\r\n\r\n\r\n\r\n@media only screen and (max-width: 767px) {\r\n    nav.nav.filter {\r\n        display: block;\r\n        padding-bottom: 140px;\r\n    }\r\n\r\n    .nav a.nav-link.filter-link {\r\n        width: 100%;\r\n        display: block;\r\n        vertical-align: middle;\r\n        text-align: center;\r\n        padding: 5px;\r\n        border: 1px solid #ccc;\r\n        background-color: #ccc;\r\n        margin-top: 5px;\r\n        color: #72777c;\r\n    }\r\n\r\n    .nav a.nav-link.filter-link.active {\r\n        background-color: #fff;\r\n        color: #72777c;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
